
import { defineComponent, ref, watchEffect, computed } from "vue";
import { ErrorMessage, Field } from "vee-validate";
import { useStore } from "vuex";
import Editor from "@tinymce/tinymce-vue";
import DropDownSection from "@/components/sections/DropDownSections.vue";

interface IStep5 {
  q5_1: string;
  q5_2: string;
  q5_3: string;
  q5_4: string;
  q5_5: string;
  q5_6: string;
  q5_7: string;
}

export default defineComponent({
  name: "step-2",
  components: {
    Field,
    ErrorMessage,
    Editor,
    DropDownSection,
  },
  setup() {
    const store = useStore();
    const listDropDownSections = [
      {
        title: "Information",
        descriptions: [{ description: " Some Information" }],
      },
    ];
    const step5 = ref<IStep5>({
      q5_1: "",
      q5_2: "",
      q5_3: "",
      q5_4: "",
      q5_5: "",
      q5_6: "",
      q5_7: "",
    });

    const currentEditorToken = computed(() => {
      return store.getters.currentEditorToken;
    });

    const submitButtonRef = ref<null | HTMLButtonElement>(null);

    const submit = () => {
      if (!submitButtonRef.value) {
        return;
      }
    };

    watchEffect(() => {
      const data = store.getters.currentSubject;
      if (data === null || data.data === undefined) return;
      step5.value.q5_1 = data.data.isAvailableEveryOne == true ? "1" : "0";
      step5.value.q5_2 =
        data.data.confidentialityExplanation != null &&
        data.data.confidentialityExplanation != undefined
          ? data.data.confidentialityExplanation
          : "";
      step5.value.q5_3 =
        data.data.subjectConfidentiality != null &&
        data.data.subjectConfidentiality != undefined
          ? data.data.subjectConfidentiality!
          : "";
      step5.value.q5_4 =
        data.data.isInformationIdentifiable == true ? "1" : "0";
      step5.value.q5_5 =
        data.data.whatIdentifiers != null &&
        data.data.whatIdentifiers != undefined
          ? data.data.whatIdentifiers!
          : "";
      step5.value.q5_6 =
        data.data.whoHaveAccess != null && data.data.whoHaveAccess != undefined
          ? data.data.whoHaveAccess!
          : "";
      step5.value.q5_7 =
        data.data.whenIdentifyData != null &&
        data.data.whenIdentifyData != undefined
          ? data.data.whenIdentifyData!
          : "";
    });

    return {
      submit,
      submitButtonRef,
      step5,
      listDropDownSections,
      currentEditorToken,
    };
  },
});
